import { chakra, useColorModeValue } from "@chakra-ui/react";
import { ComponentProps } from "react";

import LinearLogo from "@/common/assets/linear-logo.svg?react";

const ChakraLinearLogo = chakra(LinearLogo);

export type LinearConnectionIconProps = ComponentProps<
  typeof ChakraLinearLogo
> & {
  isDisabled?: boolean;
};

export function LinearConnectionIcon({
  boxSize = 4,
  isDisabled = false,
  ...boxProps
}: LinearConnectionIconProps) {
  const color = useColorModeValue("#222326", "#F4F5F8");

  return (
    <ChakraLinearLogo
      boxSize={boxSize}
      color={color}
      flexShrink={0}
      opacity={isDisabled ? 0.5 : 1}
      {...boxProps}
    />
  );
}
